import type { ReportBlock } from '@/lib/types/report'
import { GeneralTable } from './blocks/GeneralTable'
import { RankedTable } from './blocks/RankedTable'
import { NarrativeBlock } from './blocks/NarrativeBlock'
import { MarkdownBlock } from './blocks/MarkdownBlock'
import { UnsupportedBlock } from './blocks/UnsupportedBlock'
import { AttributionSankeyBlock } from './blocks/AttributionSankeyBlock'
import { ProjectGraphBlock } from './blocks/ProjectGraphBlock'
import { ContributionBar } from './blocks/ContributionBar'
import { CompositionDonut } from './blocks/CompositionDonut'
import { KpiGrid } from './blocks/KpiGrid'
import { FindingCallout } from './blocks/FindingCallout'
import { PendingSection } from './blocks/PendingSection'

export const BLOCK_REGISTRY: Record<string, React.ComponentType<{ block: ReportBlock }>> = {
  general_table: GeneralTable,
  ranked_table: RankedTable,
  narrative: NarrativeBlock,
  markdown: MarkdownBlock,
  attribution_sankey: AttributionSankeyBlock,
  project_graph: ProjectGraphBlock,
  contribution_bar: ContributionBar,
  composition_donut: CompositionDonut,
  kpi_grid: KpiGrid,
  finding_callout: FindingCallout,
  pending_section: PendingSection,
}

export function resolveBlock(type: string) {
  return BLOCK_REGISTRY[type] ?? UnsupportedBlock
}
